import GMPAPI from "../../services/gmpapi";
import DataStore from "../../store";
import { DumpError } from "../../utilities";

import SubpageSettings from "./SubpageSettings.vue";
import SubpageManageAccounts from "./SubpageManageAccounts.vue";

export const UserProfileRouterOptions = {
  mode: "history",
  base: "/user-profile",
  // If passed a hash, scroll to the hash. Otherwise, scroll to the top.
  scrollBehavior: function (to, from, savedPosition) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    { path: "/", component: SubpageSettings },
    { path: "/accounts", component: SubpageManageAccounts },
    { path: "*", redirect: "/" },
  ],
};

let knownLoggedIn = false;

export function UserProfileRouterInit(router) {
  // Enforce required login
  router.beforeEach(async (to, from, next) => {
    if (knownLoggedIn) {
      next();
    } else {
      try {
        DataStore.commit("setRouteLoading", true);
        await GMPAPI.GetCurrentUser();
        // We have auth, but may not have user info
        if (!DataStore.state.user.userinfo) {
          try {
            await DataStore.dispatch("AttemptCookieLogin");
            // Set this, so we don't try to verify login on every route change
            knownLoggedIn = true;
            next();
          } catch (err) {
            window.location.href = "/transit-login?redirect=" + encodeURIComponent(window.location.pathname + window.location.hash + window.location.search);
          }
        } else {
          // Set this, so we don't try to verify login on every route change
          knownLoggedIn = true;
          next();
        }
      } catch (err) {
        if (!(err.response && err.response.status === 401)) {
          DumpError("Profile routing error", err);
        }
        window.location.href = "/transit-login?redirect=" + encodeURIComponent(window.location.pathname + window.location.hash + window.location.search);
      } finally {
        DataStore.commit("setRouteLoading", false);
      }
    }
  });
}